import { render } from "./position.vue?vue&type=template&id=3d775b75&scoped=true&ts=true"
import script from "./position.vue?vue&type=script&lang=ts"
export * from "./position.vue?vue&type=script&lang=ts"

import "./position.vue?vue&type=style&index=0&id=3d775b75&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d775b75"]])

export default __exports__